import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

import { auth, db } from "../firebase";

import OrdersLogin from "../pages/OrdersLogin";
import AdminOrders from "../pages/AdminOrders";

const ADMIN_INACTIVITY_TIMEOUT = 30 * 60 * 1000;

function AdminOrdersRoute() {
  const [checking, setChecking] = useState(true);
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setChecking(true);

      if (!user) {
        setAdmin(false);
        setChecking(false);
        return;
      }

      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists() && userSnap.data()?.role === "admin") {
          setAdmin(true);
        } else {
          setAdmin(false);

          await signOut(auth);
        }
      } catch (error) {
        console.error("Admin verification error:", error);

        setAdmin(false);

        try {
          await signOut(auth);
        } catch (signOutError) {
          console.error("Admin verification sign-out error:", signOutError);
        }
      } finally {
        setChecking(false);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!admin) {
      return undefined;
    }

    let inactivityTimer;

    function resetInactivityTimer() {
      clearTimeout(inactivityTimer);

      inactivityTimer = setTimeout(async () => {
        try {
          await signOut(auth);
        } catch (error) {
          console.error("Admin inactivity logout error:", error);
        }
      }, ADMIN_INACTIVITY_TIMEOUT);
    }

    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, resetInactivityTimer);
    });

    resetInactivityTimer();

    return () => {
      clearTimeout(inactivityTimer);

      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, resetInactivityTimer);
      });
    };
  }, [admin]);

  if (checking) {
    return (
      <div className="orders-login">
        <div className="orders-login-inner">
          <p>CHECKING ACCESS...</p>
        </div>
      </div>
    );
  }

  if (!admin) {
    return <OrdersLogin />;
  }

  return <AdminOrders />;
}

export default AdminOrdersRoute;
